'use client';
import { useRef, useEffect } from 'react';
import { Button } from './button';
import { twMerge } from 'tailwind-merge';

export function Dialog({ title, content, actions, onClose, modalClassName }) {
  const dialogRef = useRef();
  useEffect(() => {
    if (dialogRef.current) {
      dialogRef.current.addEventListener('close', () => {
        if (onClose) {
          onClose();
        }
      });
      /* Delays opening briefly until the DOM is probably rendered and ready */
      setTimeout(() => {
        dialogRef.current?.showModal();
      }, 5);
    }
  }, [onClose]);
  return (
    <>
      <dialog
        className={twMerge(
          'modal',
          modalClassName || 'modal-bottom sm:modal-middle'
        )}
        ref={dialogRef}
      >
        <div className="modal-box">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
              ✕
            </button>
          </form>
          {!!title && <h3 className="font-bold capitalize text-lg">{title}</h3>}
          <div className="py-4">{content}</div>
          <form method="dialog">
            <div className="modal-action flex gap-2 flex-col md:flex-row">
              {actions.map((a, i) => (
                <Button
                  key={i}
                  className={twMerge(
                    'md:px-8 block',
                    !a.base && 'btn-neutral',
                    a.cancel && 'btn-outline',
                    a.destructive && 'btn-error',
                    a.className
                  )}
                  type="submit"
                  onClick={a.onClick}
                >
                  {a.label}
                </Button>
              ))}
            </div>
          </form>
        </div>
        <form method="dialog" className="modal-backdrop">
          <button>close</button>
        </form>
      </dialog>
    </>
  );
}
